import { IAjaxConfig } from '../helpers';

export class EnumApiMicroapi {
  /**
   * https://microapi-cn-in-t.lenovo.com
   * @dec 根据登录后获取的token 来换取用户的信息
   */
  readonly microapi_get_userinfo: IAjaxConfig = {
    url: '/sit/v1/sales/bpp/channel/t2/token/get',
    method: 'get',
    loading: true,
  };
}
